import type { HrefsByClient } from '../content/dontgiftguide/types';

export const getHrefForClient = (hrefs: HrefsByClient, clientIsNativeApp: boolean) => {
  return hrefs[clientIsNativeApp ? 'app' : 'web'];
};
